import React from "react";
import { makeStyles, Tooltip } from "@material-ui/core";

const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
        color: theme.palette.common.white,
        "&::before": {
            border: "1px solid #c6c6c6",
            backgroundColor: "#fff",
            boxSizing: "border-box"
        }
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: "none",
        fontSize:'inherit',
        border:"1px solid #c6c6c6"
    }
  }));
  
function BootstrapTooltip(props:any) {
    const classes = useStylesBootstrap();
  
    return <Tooltip arrow classes={classes} {...props} />;
  }

  export const ToolTip = (props:{title:string|null|undefined;children:JSX.Element})=>{
    if (!props.title) {
        return props.children;
    }
    return <BootstrapTooltip {...props}>
                <div>
                    {props.children}
                </div>
            </BootstrapTooltip>
  
  };